<script>
  import { onMount } from 'svelte';
  import CuratedByCreatorPage from './CuratedByCreatorPage.svelte';
  import CuratedByNotFound from './CuratedByNotFound.svelte';

  let config = null;
  let isLoading = true;

  async function fetchCreatorConfig() {
    // eslint-disable-next-line
    const dataloc = `${location.pathname.toLowerCase()}/data.json`;
    try {
      const result = await fetch(dataloc);
      config = await result.json();
    } catch (e) {
      // gracefully handle / 404
    } finally {
      isLoading = false;
    }
  }

  onMount(() => {
    fetchCreatorConfig();
  });
</script>

{#if isLoading}
  <div class="flex h-[100vh] w-[100vw] items-center justify-center">
    <p>loading...</p>
  </div>
{:else if config}
  <CuratedByCreatorPage
    isDynamic={config.isDynamic}
    handle={config.handle}
    profileImageUrl={config.imageUrl}
    bioLine1={config.bioLine1}
    bioLine2={config.bioLine2}
    recentLinks={config.recentLinks}
    topLinks={config.topLinks}
    previewMode={false}
  />
{:else}
  <CuratedByNotFound />
{/if}
